export const BRAND = {
  name: "Vayu Celebrations",
  tagline: "Your Event • Our Passion",
  motto: "Turning Moments Into Beautiful Memories",
  founder: "Hardik Sharma",
  role: "Event Planner",
};

export const CONTACT = {
  whatsappDisplay: "+91 88002 88018",
  whatsappNumber: "918800288018",
  instagram: "vayucelebrations",
  instagramUrl: "https://instagram.com/vayucelebrations",
  address: "B-2/123, Ashiyana 2, Moradabad",
  website: "www.vayucelebrations.com",
};

export const waLink = (text) =>
  `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(text)}`;

export const waLinkTo = (phone, text) => {
  let p = (phone || "").replace(/[^\d]/g, "");
  if (p.length === 10) p = `91${p}`;
  return `https://wa.me/${p}?text=${encodeURIComponent(text)}`;
};

export const HERO_IMG =
  "https://images.unsplash.com/photo-1643175816971-a463dee6ae61?auto=format&fit=crop&q=85&w=1200";

export const SERVICES = [
  {
    title: "Birthday Event",
    img: "https://images.unsplash.com/photo-1634037227458-abdbf697806e?auto=format&fit=crop&q=85&w=1000",
    caption: "Themed setups with balloon art, floral arches and stage styling for milestone birthdays.",
  },
  {
    title: "Anniversary",
    img: "https://images.unsplash.com/photo-1536392706976-e486e2ba97af?auto=format&fit=crop&q=85&w=1000",
    caption: "Elegant anniversary décor, balloon art and celebration setups that make your milestone feel grand.",
  },
  {
    title: "Welcome Baby",
    img: "https://images.unsplash.com/photo-1720798231764-06391343c4f9?auto=format&fit=crop&q=85&w=1000",
    caption: "Floral doorway welcomes and pastel arrangements to greet the little one home.",
  },
  {
    title: "Baby Shower",
    img: "https://images.unsplash.com/photo-1741969494307-55394e3e4071?auto=format&fit=crop&q=85&w=1000",
    caption: "Dreamy balloon clouds and blessing ceremonies for the mother-to-be.",
  },
  {
    title: "Car Decoration",
    img: "https://images.unsplash.com/photo-1571113908007-5d6aae13d73e?auto=format&fit=crop&q=85&w=1000",
    caption: "Ribbons, balloons and theme styling that turn any car into part of the celebration.",
  },
  {
    title: "Romantic Room Decoration",
    img: "https://images.unsplash.com/photo-1622429420441-60dd67f737a6?auto=format&fit=crop&q=85&w=1000",
    caption: "Candle pathways, fairy lights and petal-styled rooms for surprises and proposals.",
  },
  {
    title: "Return Gifts",
    img: "https://images.unsplash.com/photo-1765317270006-74f8a4e826bb?auto=format&fit=crop&q=85&w=1000",
    caption: "Curated hampers and hand-wrapped keepsakes your guests carry home.",
  },
  {
    title: "Cakes",
    img: "https://images.unsplash.com/photo-1693059740560-21151639561f?auto=format&fit=crop&q=85&w=1000",
    caption: "Custom-designed cakes matched to your theme and favourite flavours — from playful cartoon tiers to elegant gold-dusted showpieces, baked fresh for the big day.",
  },
];

export const scrollToId = (id) => {
  const lenis = window.__lenis;
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};
